"use client"

import { useEffect, useState, type ComponentType } from "react"
import * as LucideIcons from "lucide-react"
import { Globe } from "lucide-react"
import type { SumberIcon } from "@/shared/lib/icon-svg"
import { IkonSvg } from "./ikon-svg"
import { cariIconBrand } from "@/shared/lib/brand-icons"
import { bersihkanSvgIkon } from "@/shared/lib/icon-svg"

interface DynamicIconProps {
  iconType: SumberIcon
  iconValue: string
  warna?: string
  className?: string
}

export function DynamicIcon({ iconType, iconValue, warna, className = "w-5 h-5" }: DynamicIconProps) {
  const [BrandIcon, setBrandIcon] = useState<ComponentType<{ className?: string; color?: string }> | null>(null)

  useEffect(() => {
    let aktif = true
    if (iconType === "simpleicon" && iconValue) {
      cariIconBrand(iconValue).then((Icon) => {
        if (aktif) setBrandIcon(() => Icon)
      })
    } else {
      setBrandIcon(null)
    }
    return () => {
      aktif = false
    }
  }, [iconType, iconValue])

  if (iconType === "svg" && iconValue) {
    const svg = bersihkanSvgIkon(iconValue)
    return svg ? <IkonSvg svg={svg} warna={warna} className={className} /> : <Globe className={className} />
  }

  if (iconType === "upload" && iconValue) {
    return <img src={iconValue} alt="" className={`${className} object-contain rounded`} />
  }

  if (iconType === "simpleicon" && iconValue) {
    if (!BrandIcon) return <Globe className={`${className} opacity-40`} />
    return <BrandIcon className={className} color={warna || "#dc2626"} />
  }

  const LucideIcon = (LucideIcons as any)[iconValue] as ComponentType<{ className?: string }> | undefined
  if (LucideIcon) return <LucideIcon className={className} />

  return <Globe className={className} />
}
